var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDrawerClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 16,
  viewBox: "0 0 14 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.002 0A3 3 0 0 1 14 3.006v9.988A3.005 3.005 0 0 1 10.994 16H6l-.001-2h4.995c.516 0 .941-.388 1-.888l.006-.118V3.006C12 2.449 11.553 2 11.002 2H6L6 0ZM3.33 9h6.634V7H3.33l2.134-1.5v-.508A.99.99 0 0 0 4.471 4h-.508L.31 7.321a.897.897 0 0 0 0 1.358L3.963 12h.508a.99.99 0 0 0 .993-.992V10.5z"
})));
export default SvgDrawerClose;